import { render, staticRenderFns } from "./m-change-password.vue?vue&type=template&id=3418ed2c&"
import script from "./m-change-password.vue?vue&type=script&lang=js&"
export * from "./m-change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports